import { C } from '@ridgewill/brand';
import { deliveryLabel, deliveryTone, noDeliveryText, statusLabel, statusTone } from '../lib/notifications.js';
import { DotPill } from './ui.js';

/**
 * A send's status and delivery result, as the Sends list, a send's detail and
 * a user's recent-sends panel all render them (org-admin#131). One component so
 * the three cannot word the same send differently.
 */
export function StatusPill({ status, reason }: { status: string; reason: string | null }) {
  return <DotPill tone={statusTone(status)}>{statusLabel(status, reason)}</DotPill>;
}

export function DeliveryText({ status, delivery }: { status: string; delivery: string | null }) {
  const label = deliveryLabel(delivery);
  if (!label) return <span style={{ color: C.muted }}>{noDeliveryText(status)}</span>;
  return <DotPill tone={deliveryTone(delivery)}>{label}</DotPill>;
}
